import styled from '@emotion/styled';
import { StepConnector, stepConnectorClasses, StepLabel } from '@mui/material';
import { colors } from 'theme/colors';

const StyledWizardWrapper = styled.div`
  width: 100%;
  height: 148px;
  border-bottom: 1px solid ${colors.blue200};
  box-shadow: 0 6px 10px 0 rgba(194, 204, 243, 0.35);
  position: sticky;
  background: white;
  top: 0;
  z-index: 999;

  & h5 {
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    padding: 20px 40px 4px;
  }

  & .MuiStepper-root {
    margin-top: 20px;
  }

  & .MuiStep-root.step-error {
    .MuiStepConnector-root {
      :after {
        background-color: ${colors.error600};
      }

      .MuiStepConnector-line {
        border-color: ${colors.error600};
        border-top-width: 1px;
      }
    }
  }
`;

const StyledConnector = styled(StepConnector)`
  &.${stepConnectorClasses.alternativeLabel} {
    top: 10px;

    &:after {
      content: '';
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: ${colors.gray400};
      position: absolute;
      right: 0;
      top: -5px;
    }

    & .MuiStepConnector-line {
      border-color: ${colors.gray400};
      border-top-width: 1px;
    }

    &.Mui-completed {
      &:after {
        background-color: ${colors.success600};
      }

      .MuiStepConnector-line {
        border-color: ${colors.success600};
        border-top-width: 1px;
      }
    }
  }
`;

const StyledStepIcon = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: ${colors.gray200};

  font-size: 10px;
  line-height: 14px;
  font-weight: 700;
  color: ${colors.gray400};
  padding: 3px 7px;

  &.step-icon-active {
    background-color: ${colors.blue600};
    color: ${colors.white};
  }

  &.step-icon-completed {
    background-color: ${colors.success600};
    color: ${colors.white};
  }

  &.step-icon-error {
    background-color: ${colors.error600};
    color: ${colors.white};
  }
`;

const StyledStepLabel = styled(StepLabel)`
  & .MuiStepLabel-label {
    font-size: 12px;
    line-height: 16px;
    font-weight: 700;
    color: ${colors.blue600};
  }

  & .MuiStepLabel-label.Mui-active {
    font-size: 12px;
    line-height: 16px;
    font-weight: 700;
    color: ${colors.blue600};
  }

  & .MuiStepLabel-label.Mui-disabled {
    color: ${colors.gray400};
  }

  & .MuiStepLabel-label.Mui-completed {
    color: ${colors.success600};
  }

  & .MuiStepLabel-label.Mui-error {
    color: ${colors.error600};
  }
`;

export { StyledWizardWrapper, StyledConnector, StyledStepIcon, StyledStepLabel };
